import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchCourseData = createAsyncThunk("api/course", async () => {
  const response = await fetch(`${FULL_API_BASE_URL}/get-courses`);
  const data = await response.json();
  return data;
});

const courseSlice = createSlice({
  name: "course",
  initialState: {
    coursesdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCourseData.fulfilled, (state, action) => {
        state.loading = false;
        state.coursesdata = action.payload;
      })
      .addCase(fetchCourseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default courseSlice.reducer;
